/**
 *
 * IMPORTANT
 *
 * Toast Component has to be defined in the project Scope,
 * should be loaded and compiled after ChakraProvider
 *
 * DO NOT REFACTOR TO UI-KIT
 *
 */
import React from 'react'
import type { RenderProps, UseToastOptions } from '@chakra-ui/react'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  CloseButton,
} from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'

interface Props {
  options: UseToastOptions
  props: RenderProps
}

const Toast = ({
  options,
  props: { id, onClose },
}: Props): React.ReactElement => {
  const alertTitleId =
    // eslint-disable-next-line no-undefined
    typeof id !== 'undefined' ? `toast-${id}-title` : undefined

  return (
    <Alert
      status={options.status}
      variant={options.variant}
      id={String(id)}
      boxShadow="lg"
      width="auto"
      aria-labelledby={alertTitleId}
    >
      <AlertIcon />
      <chakra.div flex="1" maxWidth="100%">
        {options.title && (
          <AlertTitle id={alertTitleId}>{options.title}</AlertTitle>
        )}
        {options.description && (
          <AlertDescription display="block">
            {options.description}
          </AlertDescription>
        )}
      </chakra.div>
      {options.isClosable && (
        <CloseButton size="sm" onClick={onClose} marginLeft={2} />
      )}
    </Alert>
  )
}

export default Toast
